const PERMISSION_KEY = "core:api_key_permission_group_credentials";
const PAGE_URL = {
    API_KEY_PERMISSION_GROUP_CREDENTIALS_PAGE: "/admin/core/api-key-permission-group-credentials"
}

export { PERMISSION_KEY, PAGE_URL }
